import { useMedia } from "../media-queries";

import { Container, Age, Title, Description, Photo } from "./styles";

export function HappyClientsContent({ years, title, description }) {
  const size = useMedia();
  return (
    <Container size={size}>
      <Age size={size}>
        <span>{years.toLocaleString("en-US")}</span> years
      </Age>
      <div>
        <Title>{title}</Title>
        <Description>{description}</Description>
        <Photo src="../img/clients.png" alt="" />
      </div>
    </Container>
  );
}